import React from "react";
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from "../../../../components/ui/select";
import {
	Type,
	AlignLeft,
	List,
	CheckSquare,
	Circle,
	Calendar,
	FileUp,
	FileText,
	Clock,
	CalendarClock,
	Tags,
} from "lucide-react";
import { FieldType } from "../../types/formTypes";

interface FieldTypeDropdownProps {
	value: FieldType;
	onChange: (type: FieldType) => void;
}

// Exclude title and description from dropdown (title is separate button, description deprecated)
const fieldTypeConfig: Array<{
	type: FieldType;
	label: string;
	icon: React.ReactNode;
}> = [
	{ type: "text", label: "Kurzantwort", icon: <Type className="h-4 w-4" /> },
	{
		type: "textarea",
		label: "Lange Antwort",
		icon: <AlignLeft className="h-4 w-4" />,
	},
	{
		type: "checkbox",
		label: "Mehrfachauswahl",
		icon: <CheckSquare className="h-4 w-4" />,
	},
	{
		type: "radio",
		label: "Einzelauswahl",
		icon: <Circle className="h-4 w-4" />,
	},
	{
		type: "chips",
		label: "Chips",
		icon: <Tags className="h-4 w-4" />,
	},
	{ type: "select", label: "Dropdown", icon: <List className="h-4 w-4" /> },
	{
		type: "file",
		label: "Datei hochladen",
		icon: <FileUp className="h-4 w-4" />,
	},
	{
		type: "odontogram",
		label: "Zahnschema",
		icon: <FileText className="h-4 w-4" />,
	},
	{
		type: "appointment",
		label: "Termin",
		icon: <CalendarClock className="h-4 w-4" />,
	},
	{ type: "date", label: "Datum", icon: <Calendar className="h-4 w-4" /> },
	{ type: "time", label: "Zeit", icon: <Clock className="h-4 w-4" /> },
];

const FieldTypeDropdown: React.FC<FieldTypeDropdownProps> = ({
	value,
	onChange,
}) => {
	const currentConfig = fieldTypeConfig.find(
		(config) => config.type === value
	);

	return (
		<Select
			value={value}
			onValueChange={(val) => onChange(val as FieldType)}
		>
			<SelectTrigger
				className="w-[180px] h-8"
				aria-label="Feldtyp auswählen"
				data-testid="field-type-dropdown"
			>
				<SelectValue>
					{currentConfig && (
						<div className="flex items-center gap-2">
							{currentConfig.icon}
							<span>{currentConfig.label}</span>
						</div>
					)}
				</SelectValue>
			</SelectTrigger>
			<SelectContent>
				{fieldTypeConfig.map(({ type, label, icon }) => (
					<SelectItem key={type} value={type}>
						<div className="flex items-center gap-2">
							{icon}
							<span>{label}</span>
						</div>
					</SelectItem>
				))}
			</SelectContent>
		</Select>
	);
};

export default FieldTypeDropdown;
